import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import ProtectedRoute from './components/pages/common/ProtectedRoute';
import Loader from './components/pages/common/Loader';
import AuthTemp from './components/pages/auth/AuthTemp';

// Lazy imports
const ClearCookie = lazy(() => import('./components/pages/common/ClearCookie'));
const PageNotFound = lazy(() => import('./components/pages/common/PageNotFound'));
const Homepage = lazy(() => import('./components/pages/Homepage/Homepage'));
const Location = lazy(() => import('./components/pages/Location/Location'));
const PriceSearchByCategory = lazy(() => import('./components/pages/PricePromotion/PriceSearchByCategory'));
const PriceSearchByGroup = lazy(() => import('./components/pages/PricePromotion/PriceSearchByGroup'));
const PriceSearchBySKU = lazy(() => import('./components/pages/PricePromotion/PriceSearchBySKU'));
const PriceSearchComparisonBySKU = lazy(() => import('./components/pages/PricePromotion/PriceSearchComparisonBySKU'));
const PriceSearchByStyle = lazy(() => import('./components/pages/PricePromotion/PriceSearchByStyle'));
const PriceSearchBySubGroup = lazy(() => import('./components/pages/PricePromotion/PriceSearchBySubGroup'));
const StockChecker = lazy(() => import('./components/pages/Stock/StockChecker'));
const Timeout = lazy(() => import('./components/pages/Timeout/Timeout'));

ReactDOM.render(
	<BrowserRouter>
		<Suspense fallback={<Loader data={true} fullscreen="true" />}>
			<Switch>
				<Route exact path="/" component={Homepage} ></Route>
				<ProtectedRoute exact path="/location" component={Location} ></ProtectedRoute>
				<ProtectedRoute exact path="/check-stock" component={StockChecker} ></ProtectedRoute>
				<ProtectedRoute exact path="/price-lookup-by-sku" component={PriceSearchBySKU} ></ProtectedRoute>
				<ProtectedRoute exact path="/price-lookup-comparison-by-sku" component={PriceSearchComparisonBySKU} ></ProtectedRoute>
				<ProtectedRoute exact path="/price-lookup-by-style" component={PriceSearchByStyle} ></ProtectedRoute>
				<ProtectedRoute exact path="/price-lookup-by-category" component={PriceSearchByCategory} ></ProtectedRoute>
				<ProtectedRoute exact path="/price-lookup-by-group" component={PriceSearchByGroup} ></ProtectedRoute>
				<ProtectedRoute exact path="/price-lookup-by-subgroup" component={PriceSearchBySubGroup} ></ProtectedRoute>
				<Route path="/clearcookie" component={ClearCookie} ></Route>
				<Route path="/timeout" component={Timeout} ></Route>
				<Route path="/auth" component={AuthTemp} />
				<Route path="*" component={PageNotFound} status={404} />
			</Switch>
		</Suspense>
	</BrowserRouter>,
	document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js